import { Outlet } from "react-router-dom";

import DashboardHeader from "../Header";

const DashboardContent = () => {
  return (
    <div className="h-screen w-full bg-gray-100" style={{ maxWidth: `100%`, maxHeight: `calc(100vh + 14rem` }}>
      <DashboardHeader />
      {/*Scrollbar Start*/}
      <div style={{position: "relative", height: "100%", width: "100%", overflow: "hidden"}}>
        <div style={{position: "absolute", inset: "0px", overflow: "auto"}}>
          <div className="p-4 mb-16">
            <Outlet />
          </div>
        </div>
      </div>
      {/*Scrollbar End*/}
    </div>
  );
};

export default DashboardContent;
